import '../styles/tabControl.less';
import $ from 'jquery';
import * as common from '../../../shared/modules/common';

function toggleClass(element, classNameString) {
    var classList, classIndex;

    if (!element) { return; }

    if (element.classList) {
        element.classList.toggle(classNameString);
    } else if (Array.prototype.indexOf) { // IE 9
        classList = element.className.split(' ');
        classIndex = classList.indexOf(classNameString);
        if (classIndex !== -1) {
            classList.splice(classIndex, 1);
        } else {
            classList.push(classNameString);
        }
        element.className = classList.join(' ');
    } else { // IE 8
        if (!element.className) {
            element.className = classNameString;
        } else if (element.className.indexOf(classNameString) !== -1) {
            element.className = element.className.replace(classNameString, '').replace(/\s+/gi, ' ');
        } else {
            element.className = element.className.concat(' ', classNameString);
        }
    }
}

function switchTab(newTab, id) {
    var tabControlElement = newTab.parentElement,
        previousActive = tabControlElement.querySelector('.uwr-tab-control-active'),
        previousId = null;

    if (previousActive && previousActive.querySelector('a')) {
        previousId = previousActive.querySelector('a').getAttribute('href');
        toggleClass(previousActive, 'uwr-tab-control-active');
    }

    if (previousId) {
        toggleClass(document.querySelector(previousId + '.uwr-tab-shown'), 'uwr-tab-shown');
    }

    toggleClass(document.querySelector(id), 'uwr-tab-shown');
    toggleClass(newTab, 'uwr-tab-control-active');
}

function clickHandler(event) {
    var id;

    id = this.querySelector('a') && // null check
            this.querySelector('a').getAttribute('href');

    if (id && document.querySelector(id)) {
        switchTab(this, id);
        event.preventDefault();
    }
}

function clickHandlerIE8(event) {
    var id,
        targetListItem = this.event.srcElement;

    if (targetListItem.tagName === 'A') {
        id = targetListItem.getAttribute('href');
        targetListItem = targetListItem.parentElement;
    } else {
        id = targetListItem.querySelector('a') && // null check
                targetListItem.querySelector('a').getAttribute('href');
    }

    if (id && document.querySelector(id)) {
        switchTab(targetListItem, id);
        event.returnValue = false;
    }
}

function setEventListeners(tabControlElement) {
    var tabs = tabControlElement.querySelectorAll('ul.uwr-tab-control li:not(.uwr-tab-group-right)');
    for (var i = 0, tl = tabs.length; i < tl; i++) {
        tabs[i].addEventListener('click', clickHandler);
    }
}

function setEventListenersIE8(tabControlElement) {
    var tabs = tabControlElement.querySelectorAll('ul.uwr-tab-control li');
    for (var i = 0, tl = tabs.length; i < tl; i++) {
        if (!tabs[i].className || tabs[i].className.indexOf('uwr-tab-group') === -1) {
            tabs[i].attachEvent('onclick', clickHandlerIE8);
        }
    }
}

function findActiveTab(tabControlElement, IE8) {
    var firstTabLink,
        firstTabId = null;

    if (!IE8) {
        firstTabLink = tabControlElement.querySelector('.uwr-tab-control-active > a[href^="#"]')
                    || tabControlElement.querySelector('li > a[href^="#"]');
    } else {
        firstTabLink = tabControlElement.querySelector('.uwr-tab-control-active > a[href]')
                    || tabControlElement.querySelector('li > a[href]');
    }

    if (firstTabLink) {
        firstTabId = firstTabLink.getAttribute('href');
    }

    if (firstTabId && firstTabId.match(/^#/)) {
        switchTab(firstTabLink.parentElement, firstTabId);
    }
}

function initTabControl(element) {
    if (!element.hasAttribute('data-initialized')) {
        element.setAttribute('data-initialized', '');

        if (!common.isIe8()) {
            findActiveTab(element);
            setEventListeners(element);
        } else {
            findActiveTab(element, 'IE8');
            setEventListenersIE8(element);
        }
    }
}

/**
 * Supported use cases:
 * - init();
 * - init(callback);
 * - init(selector);
 * - init(selector, callback);
 */
export function init(arg1, arg2) {
    var selector,
        callback;

    if (arguments.length === 0) {
        selector = '.uwr-tab-control';
        callback = null;
    } else if (arguments.length === 1) {
        if ($.type(arg1) === 'string') {
            selector = arg1;
            callback = null;
        } else if ($.type(arg1) === 'function') {
            selector = '.uwr-tab-control';
            callback = arg1;
        }
    } else if (arguments.length === 2) {
        selector = arg1;
        callback = arg2;
    }

    $(selector).each(function (i, element) {
        if (common.hasClass(element, 'uwr-tab-control')) {
            initTabControl(element);
        }
    });

    common.invoke(callback);
}



//////////////////
// WEBPACK FOOTER
// ./widgets/TabControl/js/tabControl.js
// module id = 42
// module chunks = main